import BaseProxy from './Base';

class VenuesProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('venues', parameters, 'api/v1');
  }

  getVenues(query) {
    const parameters = {};
    if (!Object.prototype.hasOwnProperty.call(query, 'page')) {
      parameters.page = 1;
    } else {
      parameters.page = query.page;
    }
    if (!Object.prototype.hasOwnProperty.call(query, 'limit')) {
      parameters.limit = 30;
    } else {
      parameters.limit = query.limit;
    }
    if (Object.prototype.hasOwnProperty.call(query, 'column')) {
      parameters.order = `${query.order === 'descending' ? '-' : ''}${query.column}`;
    } else {
      parameters.order = 'name';
    }
    if (Object.prototype.hasOwnProperty.call(query, 'filter')) {
      parameters.q = query.filter;
    }
    this.setParameters(parameters);
    return this.load();
  }

  search(keyword) {
    this.setParameter('q', keyword);
    return this.load();
  }

  delete(venuesIds) {
    const ids = Array.isArray(venuesIds) ? venuesIds : [venuesIds];
    return this.submit('delete', `/${this.endpoint}`, { venues_ids: ids });
  }
}

export default VenuesProxy;
